<template>
  <CustomRow>
    <v-card class="mt-5">
      <v-stepper v-model="registerStep">
        <template v-if="!$vuetify.breakpoint.xs">
          <div class="d-flex justify-center align-center stepperPadding">
            <template v-for="(value, i) in steps">
              <v-btn fab depressed :class="stepStatus(i + 1)" class="mr-2 stepNum" :key="`step-check-${i}`">
                <v-icon color="white" v-if="registerStep > i + 1">mdi-check</v-icon>
                <template v-else>{{ i + 1 }}</template>
              </v-btn>
              <div :class="stepStatus(i + 1)" class="stepText" :key="`step-value-${i}`">
                {{ value }}
              </div>
              <v-divider class="mx-3 stepDivider" :class="stepStatus(i + 1)" v-if="i !== steps.length - 1"
                :key="value"></v-divider>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="px-5">
            <div class="d-flex justify-center align-center stepperPadding">
              <template v-for="(value, i) in steps">
                <v-btn fab depressed :class="stepStatus(i + 1)" class="stepNum" :key="i">
                  <v-icon color="white" v-if="registerStep > i + 1">mdi-check</v-icon>
                  <template v-else>{{ i + 1 }}</template>
                </v-btn>
                <v-divider class="stepDivider" :class="stepStatus(i + 1)" v-if="i !== steps.length - 1"
                  :key="value"></v-divider>
              </template>
            </div>
            <div class="d-flex justify-space-between align-center mt-2 mb-5">
              <div v-for="(value, i) in steps" :class="stepStatus(i + 1)" class="stepText" :key="i">
                {{ value }}
              </div>
            </div>
          </div>
        </template>

        <v-divider></v-divider>

        <v-stepper-items>
          <v-stepper-content :step="1">
            <ValidateMobile @nextStep="registerStep = 2" />
          </v-stepper-content>
          <v-stepper-content :step="2">
            <SetPassword @nextStep="registerStep = 3" />
          </v-stepper-content>
          <v-stepper-content :step="3" class="px-0">
            <div class="my-6">
              <div class="text-page-title font-weight-bold text-center mb-6">
                填寫會員基本資料
              </div>
              <UserInfoForm v-if="registerStep == 3" :isRegister="true" :propsEditMode="true"
                :registerEmail="$store.state.register.email" @nextStep="registerStep = 4" />
            </div>
          </v-stepper-content>
          <v-stepper-content :step="4">
            <div class="mb-10">
              <SendEmailForm :email="$store.state.register.email" />
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </CustomRow>
</template>

<script>
import ValidateMobile from "./ValidateMobile.vue";
import SetPassword from "./SetPassword.vue";
import UserInfoForm from "@/views/auth/components/UserInfoForm.vue";
import SendEmailForm from "@/views/auth/components/SendEmailForm.vue";

export default {
  components: {
    ValidateMobile,
    SetPassword,
    UserInfoForm,
    SendEmailForm
  },
  metaInfo() {
    return {
      title: `註冊 - ${this.$t("app_name")}`,
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `註冊 - ${this.$t("app_name")}`,
          "url": window.location.href
        }
      }]
    }
  },
  data() {
    return {
      registerStep: 1,
      steps: ["手機驗證", "設定密碼", "填寫資料", "信箱驗證"]
    };
  },
  methods: {
    nextStep(step) {
      this.registerStep = parseInt(step) + 1;
    },
    stepStatus(index) {
      if (this.registerStep == index) return "currStep";
      if (this.registerStep > index) return "checkedStep";
      else return "afterStep";
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-stepper__header {
  height: 100px;
  padding: 0 40px;
  box-shadow: none;

  .v-stepper__label {
    font-weight: 500;
  }

  .currStep {
    .v-stepper__step__step {
      color: $primary-1;
      background-color: white !important;
      border: 2px solid;
    }

    .v-stepper__label {
      color: $primary-1;
    }
  }

  .colorDivider {
    background-color: $primary-1;
  }

  @media screen and (max-width: 600px) {
    .v-stepper__step {
      padding: 0;
    }
  }
}

.stepperPadding {
  padding: 40px 100px 40px 100px;

  @media screen and (max-width: 600px) {
    padding: 32px 16px 0px 16px;
  }

  @media only screen and (min-width: 600px) and (max-width: 960px) {
    padding: 40px 40px 40px 40px;
  }
}

.stepNum {
  width: 30px;
  height: 30px;
  font-size: 15px;

  &.currStep {
    background-color: white !important;
    color: $primary-1;
    border: 2px solid $primary-1;
  }

  &.checkedStep {
    background-color: $primary-1 !important;
    color: white;
  }

  &.afterStep {
    background-color: #c4c4c4 !important;
    color: white;
  }
}

.stepText {
  font-weight: bold;

  &.currStep {
    color: $primary-1;
  }

  &.checkedStep {
    color: #444444;
  }

  &.afterStep {
    color: #c4c4c4;
  }
}

.stepDivider {
  border-top: 2px solid #c4c4c4;

  &.checkedStep {
    border-top: 2px solid $primary-1;
  }
}
</style>
